<template>
  <div>
    <div class="router-link" v-if="type == 1">
      <router-link :class="linkClass" to="/try">
        申请使用
        <svg-icon icon-class="icon_arrow_right" class-name="icon_arrow_right"></svg-icon>
      </router-link>
    </div>
    <div :class="linkClass" v-else>
      <h3>现在申请使用 立享优惠！</h3>
      <router-link to="/try">申请使用</router-link>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.a-link {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 270px;
  height: 72px;
  border-radius: 4px;
  font-size: 32px;
  font-weight: 400;
  color: #fff;
  line-height: 72px;
  margin: 84px 0;
  text-align: center;
  background: #425bff;
  .icon_arrow_right {
    margin-left: 8px;
    font-size: 44px;
    font-weight: bold;
    color: #fff;
    display: inline-block;
  }
}

.apply {
  width: 100%;
  color: #425bff;
  background: #425bff;
  height: 240px;
  padding: 42px 0 24px;
  h3 {
    color: #fff;
    text-align: center;
    font-size: 40px;
    font-weight: 300;
    line-height: 56px;
  }
  a {
    display: block;
    background: #fff;
    color: inherit;
    line-height: 80px;
    margin: 32px auto 0;
    text-align: center;
    width: 320px;
    height: 80px;
    border-radius: 4px;
    font-size: 28px;
    font-weight: 400;
  }
}
</style>
<script>
export default {
  props: {
    className: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      defaule: "1"
    }
  },
  computed: {
    linkClass() {
      if (this.type == 1) {
        return `a-link ${this.className}`;
      } else {
        return `apply ${this.className}`;
      }
    }
  }
};
</script>